// extracted by mini-css-extract-plugin
export var cardTitle = "_jh-1";
export var commentBubble = "_jh-e";
export var commentForm = "_jh-a";
export var commentInput = "_jh-b";
export var commentLabel = "_jh-d";
export var commentPrompt = "_jh-9";
export var csatCard = "_jh-0";
export var feedbackSection = "_jh-7";
export var starDisabled = "_jh-6";
export var starEmpty = "_jh-5";
export var starFilled = "_jh-4";
export var starWrapper = "_jh-3";
export var starsContainer = "_jh-2";
export var submittedComment = "_jh-c";
export var thankYouText = "_jh-8";